import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IRequestParametersOsd, IExceptionList } from "../models/osd";
import { throwApiError } from "./apiError";
import { getHeaderActionType } from "../helpers";

/**
 * GET API call using Axios
 * @param params - Request parameters
 * @param action - API action (default: "list")
 * @param signal - AbortSignal for request cancellation
 * @returns - Array of Exception List of type IExceptionList[]
 */

export const getExceptionList = async (
  params: IRequestParametersOsd,
  action: string = "list",
  partial_headers?: Record<string, string>,
  signal?: AbortSignal
): Promise<IExceptionList> => {
  try {
    let headers = {
      "Content-Type": "application/json",
      "OSD-Section-Name": "dataTable",
      "OSD-Action-Type": getHeaderActionType(action),
      "OSD-Exception-Type": params.osdType?.join(", "),
      "OSD-Exception-Number": params.osdNumber,
      "OSD-Reporting-Terminal": params.reporting?.join(", "),
      "OSD-Origin-Terminal": params.origin?.join(", "),
      "OSD-Destination-Terminal": params.destination?.join(", "),
    };
    if (partial_headers) {
      headers = { ...headers, ...partial_headers };
    }
    const response = await axios.post(
      `${getUrl(ApiType.EXCEPTIONS_LIST)}/${action}`,
      params,
      { headers, signal }
    );
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.getExceptionList);
  }
};
